module.exports = __webpack_public_path__ + "assets/images/logo-intro_04cb083d395cded8cf0974754f58b0ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-intro.png
// module id = 118
// module chunks = 0